<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">DETALHAR SERVIÇO</span>
                <div class="float-right">
                    <b-button 
                        variant="secondary" 
                        size="sm" 
                        @click="voltar()"
                    >
                        <i class="fa fa-arrow-left"></i> Voltar
                    </b-button>
                </div>
            </b-card-header>
            <b-card-body>
                <div v-if="comprometimento">
                    <comprometimento-dados
                        :comprometimento="comprometimento"
                    ></comprometimento-dados>
                    <comprometimento-documentacao
                        class="mt-4"
                        v-model="comprovacoes"
                        :comprometimento="comprometimento"
                        v-if="comprometimento.contratoTipoEspecial"
                        :naoPermiteEditar="naoPermiteEditar"
                    ></comprometimento-documentacao>
                    <comprometimento-pesquisa
                        class="mt-2"
                        v-model="avaliacoes"
                        :comprometimento="comprometimento"
                        :naoPermiteEditar="naoPermiteEditar"
                    >
                    </comprometimento-pesquisa>
                    
                    <div class="mt-4" v-if="permitirAprovar || permitirReprovar">
                        <b-button 
                            v-if="permitirAprovar"
                            variant="success" 
                            class="mr-2"
                            @click="aprovar()"
                        >
                            <i class="fa fa-check"></i> Aprovar
                        </b-button>
                        <b-button 
                            v-if="permitirReprovar"
                            variant="danger"
                            @click="reprovar()"
                        >
                            <i class="fa fa-times"></i> Reprovar
                        </b-button>
                    </div>
                </div>
                <div v-else>
                    <p>Carregando dados do serviço...</p>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import ComprometimentoDocumentacao from '../../aprovadores/ComprometimentoDocumentacao'
import ComprometimentoPesquisa from '../../aprovadores/ComprometimentoPesquisa'
import ComprometimentoDados from '../../aprovadores/ComprometimentoDados'
import { comprometimentoStatus } from '../../comprometimentos/ComprometimentoStatus'
import ServicosServicos from './ServicosServicos'

export default {
    name: 'GerentesServicoDetalhar',
    components: {
        ComprometimentoDocumentacao,
        ComprometimentoPesquisa,
        ComprometimentoDados
    },

    props: {
        idComprometimento: {
            type: [String, Number],
            default() {
                return this.$route.params.id
            }
        },
        permitirAprovar: {
            type: Boolean,
            default() {
                return this.$temAcessoView('GESCON-GER-APROV-00')
            }
        },
        permitirReprovar: {
            type: Boolean,
            default() {
                return this.$temAcessoView('GESCON-GER-APROV-00')
            }
        },
        rotaVoltar: {
            type: String,
            default: 'Gescon_Gerentes_Servicos_Listagem'
        }
    },

    data() {
        return {
            comprometimento: null,
            comprovacoes: null,
            avaliacoes: null,
            carregando: false
        }
    },

    mounted() {
        this.carregarComprometimento()
    },

    methods: {
        async carregarComprometimento() {
            this.carregando = true
            try {
                // Implementar método para carregar comprometimento específico
                // Por enquanto vamos simular que temos os dados
                this.comprometimento = {
                    idComprometimento: this.idComprometimento,
                    status: comprometimentoStatus.EM_APROVACAO
                }
                
                this.comprovacoes = {
                    comprovacao01: this.comprometimento.comprovacao01,
                    comprovacao02: this.comprometimento.comprovacao02
                }
                this.avaliacoes = { avaliacoes: this.comprometimento.avaliacoes }
            } catch (error) {
                console.error('Erro ao carregar comprometimento:', error)
                this.$toast.error('Erro ao carregar dados do serviço')
            } finally {
                this.carregando = false
            }
        },

        aprovar() {
            // Implementar lógica de aprovação
            this.$toast.success('Serviço aprovado com sucesso!')
            this.voltar()
        },

        reprovar() {
            // Implementar lógica de reprovação
            this.$toast.success('Serviço reprovado com sucesso!')
            this.voltar()
        },

        voltar() {
            this.$router.push({ name: this.rotaVoltar })
        }
    },

    computed: {
        naoPermiteEditar() {
            return this.comprometimento && this.comprometimento.status == comprometimentoStatus.APROVADA
        }
    }
}
</script>
